import { ListAction, ListIncidentAction, ActionType } from "@/features/Actions/Action";
import UploadedPlatformDocumentMetadata from "@/features/PlatformDocuments/UploadedPlatformDocumentMetadata";

export default class ActionRequestModel {
    constructor(action: ListAction) {
        this.id = action.id;
        this.userIDs = action.userIDs;
        this.description = action.description;
        this.actionType = action.actionType;
        this.uploadedPlatformDocumentMetadatas = action.uploadedPlatformDocumentMetadatas;
        this.platformDocumentMetadataIDs = action.platformDocumentMetadataIDs;
    }

    id: string | null = null;
    userIDs: string[] = [];
    description: string = "";
    actionType: ActionType = ActionType.ComplianceIncidentAction;
    uploadedPlatformDocumentMetadatas: UploadedPlatformDocumentMetadata[] = [];
    platformDocumentMetadataIDs: string[] = [];
}

export class IncidentActionRequestModel extends ActionRequestModel {
    constructor(action: ListIncidentAction) {
        super(action);
        this.incidentID = action.incidentID;
    }

    incidentID: string | null = null;
}

export class ActionContainer {
    incidentAction: IncidentActionRequestModel | null = null;
    action: ActionRequestModel | null = null;
}
